import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuList,
  Stack,
  Select,
  Spinner,
  Text,
  useToast 
} from "@chakra-ui/react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useDispatch } from "react-redux";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import SearchTable2 from "components/Tables/SearchTable2";
import React, { useEffect, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { ordersApiAction } from "stores/redux/apiSlices/orderApi/orderApiSlice";
import { localStore } from "stores/localStore";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

function OrderList({ handleAddClient, handleEdit, handleDelete }) {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({
    status: "",
    deliveryDate: "",
    start_date: "",
    end_date: "",
  });

  const { data, isLoading, refetch } = ordersApiAction.getOrdersApi(filters, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  const toast = useToast();

  const orderListData = data?.data?.orders;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

const handleExportClick = async () => {
  const hasNewStatus = orderListData?.some(
    (order) =>
      order?.orderStatus?.toLowerCase?.() === "new" ||
      order?.orderStatus?.toLowerCase?.() === "νέα"
  );

  if (!hasNewStatus) {
    toast({
      title: "Export Blocked",
      description: "No orders with status 'Νέα' (New) found.",
      status: "warning",
      duration: 4000,
      isClosable: true,
    });
    return;
  }

  try {
    const exportFilters = {
      ...filters,
      mode: "export",
    };

    const params = new URLSearchParams(exportFilters).toString();

    const headers = new Headers({
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const token = localStore.getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    const response = await fetch(
      `https://api-nanobyte.ninjademo.in/api/order/?${params}`,
      {
        method: "GET",
        headers,
      }
    );

    const contentType = response.headers.get("content-type");
    if (
      !contentType?.includes(
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      )
    ) {
      console.error("Unexpected response format.");
      return;
    }

    const blob = await response.blob();
    const contentDisposition = response.headers.get("content-disposition");

    const formattedDeliveryDate = formatDate(filters.deliveryDate);
    const todayFormatted = formatDate(new Date().toISOString().split("T")[0]);

    const fileName =
      contentDisposition?.split("filename=")[1]?.replace(/"/g, "") ||
      `Orders_${formattedDeliveryDate || todayFormatted}.xlsx`;

    saveAs(blob, fileName);
  } catch (error) {
    console.error("Export failed:", error);
    toast({
      title: "Export Failed",
      description: "Something went wrong while exporting.",
      status: "error",
      duration: 4000,
      isClosable: true,
    });
  }
};


  const CustomInput = React.forwardRef(
    ({ value, onClick, placeholder }, ref) => (
      <input
        type="text"
        onClick={onClick}
        ref={ref}
        value={value}
        placeholder={placeholder}
        readOnly
        style={{
          border: "1px solid #ccc",
          padding: "8px 12px",
          borderRadius: "4px",
          width: "100%",
          fontSize: "14px",
          cursor: "pointer",
          backgroundColor: "#fff",
        }}
      />
    )
  );

  const handlestart_dateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      const formatted = format(date, "yyyy-MM-dd");
      setFilters((prev) => ({
        ...prev,
        start_date: formatted,
        deliveryDate: "", // clear deliveryDate
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        start_date: "",
      }));
    }
  };

  const handleend_dateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      const formatted = format(date, "yyyy-MM-dd");
      setFilters((prev) => ({
        ...prev,
        end_date: formatted,
        deliveryDate: "", // clear deliveryDate
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        end_date: "",
      }));
    }
  };

  const handleDeliveryDateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      const formatted = format(date, "yyyy-MM-dd");
      setFilters((prev) => ({
        ...prev,
        deliveryDate: formatted,
        start_date: "", // clear start_date
        end_date: "",
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        deliveryDate: "",
      }));
    }
  };

  return (
    <Flex direction="column" pt={{ sm: "125px", md: "75px" }}>
      <Flex
        direction={{ sm: "column", md: "row" }}
        justify="space-between"
        align="center"
        w="100%"
        mb="24px"
      >
        <Button
          variant="no-hover"
          bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
          w="125px"
          h="35px"
          color="#fff"
          fontSize="xs"
          fontWeight="bold"
          onClick={handleAddClient}
        >
          ΝΕΑ ΠΑΡΑΓΓΕΛΙΑ
        </Button>

        <Stack direction="row" spacing="10px">
          {/* Filter Menu */}
          <Menu>
            <MenuButton
              as={Button}
              rightIcon={<IoIosArrowDown />}
              color="gray.700"
              w="125px"
              h="35px"
              bg="#fff"
              fontSize="xs"
            >
              ΦΙΛΤΡΑ
            </MenuButton>
            <MenuList p={4}>
              <Stack spacing={3}>
                <Select
                  placeholder="Κατάσταση Παραγγελίας"
                  value={filters.status}
                  onChange={(e) =>
                    setFilters((prev) => ({ ...prev, status: e.target.value }))
                  }
                  fontSize="14px"
                >
                  <option value="NEW">Νέες Παραγγελίες</option>
                  <option value="COMPLETED">Ολοκληρωμένες</option>
                  <option value="CANCELLED">Ακυρωμένες</option>
                </Select>

                <DatePicker
                  selected={
                    filters.start_date ? new Date(filters.start_date) : null
                  }
                  onChange={handlestart_dateChange}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="Ημ/νία Παραγγελίας"
                  customInput={<CustomInput placeholder="dd-mm-yyyy" />}
                  isClearable
                />
                {filters.start_date && (
                  <DatePicker
                    selected={
                      filters.end_date ? new Date(filters.end_date) : null
                    }
                    onChange={handleend_dateChange}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Ordered End Date"
                    customInput={<CustomInput placeholder="dd-mm-yyyy" />}
                    isClearable
                    minDate={new Date(filters.start_date)}
                  />
                )}

                <Button
                  size="sm"
                  colorScheme="red"
                  onClick={() =>
                    setFilters((prev) => ({
                      ...prev,
                      start_date: "",
                      end_date: "",
                      status: "",
                    }))
                  }
                >
                Εκκαθάριση
                </Button>
              </Stack>
            </MenuList>
          </Menu>

          {/* Export Menu */}
          <Menu>
            <MenuButton
              as={Button}
              rightIcon={<IoIosArrowDown />}
              color="gray.700"
              w="125px"
              h="35px"
              bg="#fff"
              fontSize="xs"
              fontWeight="bold"
            >
              ΕΞΑΓΩΓΗ
            </MenuButton>
            <MenuList p={4}>
              <Stack spacing={3}>
                <DatePicker
                  selected={
                    filters.deliveryDate ? new Date(filters.deliveryDate) : null
                  }
                  onChange={handleDeliveryDateChange}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="Ημέρα Παράδοσης"
                  customInput={<CustomInput placeholder="dd-mm-yyyy" />}
                  isClearable
                />
                <Button
                  size="sm"
                  colorScheme="blue"
                  onClick={handleExportClick}
                >
                  Εξαγωγή (xls)
                </Button>
                <Button
                  size="sm"
                  colorScheme="red"
                  onClick={() =>
                    setFilters((prev) => ({ ...prev, deliveryDate: "" }))
                  }
                >
                  Εκκαθάριση
                </Button>
              </Stack>
            </MenuList>
          </Menu>
        </Stack>
      </Flex>

      {/* Orders Table or Spinner */}
      <Card px="0px">
        <CardBody>
          {isLoading ? (
            <Flex
              justify="center"
              align="center"
              direction="column"
              minH="300px"
              w="100%"
            >
              <Spinner
                size="xl"
                thickness="4px"
                speed="0.65s"
                color="blue.500"
              />
              <Text mt={4} fontSize="md" color="gray.600">
                Loading orders...
              </Text>
            </Flex>
          ) : (
            <SearchTable2
              tableData={Array.isArray(orderListData) ? orderListData : []}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          )}
        </CardBody>
      </Card>
    </Flex>
  );
}

export default OrderList;
